import {
  ReportingImportNormalizationIssue,
  ReportingImportNormalizationIssueCandidate,
} from '../reporting/reporting-import.model';
import { SupportingTableId } from '../reporting/supporting-table.model';

export enum ApplyReportingImportNormalizationResolutionRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  issueId = 'issueId',
  selectedCandidateId = 'selectedCandidateId',
  resolvedValue = 'resolvedValue',
  supportingTableId = 'supportingTableId',
  supportingTableValues = 'supportingTableValues',
}

export interface ApplyReportingImportNormalizationResolutionRequest {
  [ApplyReportingImportNormalizationResolutionRequestKeys.runId]?: string | null;
  [ApplyReportingImportNormalizationResolutionRequestKeys.uploadActionId]?: string | null;
  [ApplyReportingImportNormalizationResolutionRequestKeys.issueId]: string;
  [ApplyReportingImportNormalizationResolutionRequestKeys.selectedCandidateId]?: string | null;
  [ApplyReportingImportNormalizationResolutionRequestKeys.resolvedValue]?: string | null;
  [ApplyReportingImportNormalizationResolutionRequestKeys.supportingTableId]?: SupportingTableId | null;
  [ApplyReportingImportNormalizationResolutionRequestKeys.supportingTableValues]?: Record<string, unknown> | null;
}

export interface ApplyReportingImportNormalizationResolutionResponse {
  issue: ReportingImportNormalizationIssue;
  selectedCandidate: ReportingImportNormalizationIssueCandidate | null;
  unresolvedCount: number;
  resolvedCount: number;
  allResolved: boolean;
}
